import axios from 'axios'
import { API_DHL_URL } from '../lib/env'

export const DHL_API = axios.create({
  baseURL: API_DHL_URL,
})
